import { CycEsriMap } from 'esri-map-react';

export default CycEsriMap;
